import { defineComponent as _defineComponent } from 'vue'
import {Configuration} from "@/app/helpers/QueryParams";
import {computed, ref} from "vue";
import InfoButton from "@/components/InfoButton.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContractConfiguration',
  props: {
    config: null,
    title: null
  },
  setup(__props: any) {

const props = __props as {
  config: Configuration;
  title: string;
};



const durations = computed(() => {
  if (props.config.edition === null) {
    return []
  }
  return props.config.edition.getDurations(undefined)
})
const mileages = computed(() => {
  if (props.config.edition === null) {
    return []
  }
  return props.config.edition.getMileages(props.config.duration ?? undefined)
})

return { __sfc: true,props, durations, mileages, InfoButton }
}

})